export default function getServerModuleReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SERVER_MODULE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SERVER_MODULE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SERVER_MODULE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}